var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex"},style:({fontSize:_vm.size+'rem',width: _vm.width+'rem'})},[_c('div',{staticClass:"label",style:({width:_vm.labelWidth+'rem'})},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }